export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14254.f364f9e9.jpg";